import { TinyLoader } from '@/components/loaders'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { trpc } from '@/utils/trpc'
import { SignedIn, SignedOut, UserButton, useAuth, useUser } from '@clerk/clerk-react'
import { CreditCard, Home, LogIn, Menu, UserRoundPlus } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { toast } from 'sonner'

const TopNav = () => {
  const router = useRouter()
  const { user } = useUser()

  const { isLoading, mutateAsync } = trpc.getBillingPortalUrl.useMutation(undefined)

  const isSubscribed = user?.publicMetadata.isSubscribed

  return (
    <div className="select-none p-4 z-10 w-full items-center justify-between font-mono text-sm lg:flex grid grid-cols-2">
      <Link
        rel="canonical"
        href={isSubscribed ? '/home' : '/'}
        className="flex justify-center w-fit"
      >
        <Image
          className="object-scale-down h-8 w-8"
          src="/images/logo.png"
          alt="Logo"
          width={200}
          height={300}
        />
        <p className="my-auto ml-4 hidden sm:block bg-gray-100 text-gray-600 px-3 py-1 rounded ">
          v<span className="font-sans">0</span> report
        </p>
      </Link>

      <div className="ml-auto">
        <SignedIn>
          <div className="w-fit flex items-center gap-4">
            {isSubscribed ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button aria-label="Open Menu" className="cursor-pointer">
                    <Menu />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-72 mr-12 py-4">
                  <DropdownMenuItem>
                    <Link
                      href="/home"
                      className="h-full w-full flex flex-row items-center p-0 m-0"
                      passHref
                    >
                      <Home className="mx-6 h-5 w-5 text-zinc-400 " />
                      <span>Home</span>
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    className="cursor-pointer"
                    onClick={async () => {
                      toast.info('Redirecting to billing portal')
                      const data = await mutateAsync()

                      if (data?.billingPortalUrl) {
                        router.push(data?.billingPortalUrl)
                      } else {
                        toast.error(
                          "Sorry, we couldn't get you billing portal, please try again later."
                        )
                      }
                    }}
                  >
                    <CreditCard className="mx-6 h-5 w-5 text-zinc-400" />
                    <div
                    // href={billingPortalData?.billingPortalUrl ?? ""}
                    >
                      {isLoading ? <TinyLoader /> : <span>Billing</span>}
                    </div>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <Link href={'/pricing'}>
                <Button className="mr-4" variant={'zincLink'}>
                  Pricing
                </Button>
              </Link>
            )}
            <UserButton afterSignOutUrl="/" />
          </div>
        </SignedIn>
        <SignedOut>
          <div className="sm:hidden block">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Menu />
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-72 mr-12 py-4">
                <Link
                  href="/auth/signin
                "
                  className="w-full"
                >
                  <DropdownMenuItem>
                    <UserRoundPlus className="mx-6 text-zinc-400 " />

                    <span>Sign in</span>
                  </DropdownMenuItem>
                </Link>
                <DropdownMenuItem className="bg-zinc-800 text-primary-foreground hover:bg-zinc-800/90 px-4 py-2 mt-1 ">
                  <LogIn className="ml-3 mr-6 text-zinc-400" />
                  <Link href="/auth/signup" className="w-full">
                    <span>Sign up</span>
                  </Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
          <div className="flex items-center hidden sm:block">
            <Link href="https://blog.v0.report/">
              <Button className="mr-4" variant={'zincLink'}>
                Blog
              </Button>
            </Link>
            <Link href={'/pricing'}>
              <Button className="mr-4" variant={'zincLink'}>
                Pricing
              </Button>
            </Link>

            <Link href={'/auth/signin'}>
              <Button className="mr-4" variant={'zincLink'}>
                Sign in
              </Button>
            </Link>

            <Link
              className="h-8 rounded-md px-4 inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-zinc-800 text-primary-foreground hover:bg-zinc-800/90 "
              href={'/auth/signup'}
            >
              Sign up
            </Link>
          </div>
        </SignedOut>
      </div>
    </div>
  )
}

export default TopNav
